var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:_vm.b(),style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('p',{style:(_vm.styleName)},[_vm._v(_vm._s(_vm.nowDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }